"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BenefitCard = void 0;
exports.default = MyBenefits;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const cancelable_promise_1 = require("cancelable-promise");
const react_native_fontawesome_1 = require("@fortawesome/react-native-fontawesome");
const react_native_1 = require("react-native");
const react_i18next_1 = require("react-i18next");
const CardTitle_1 = __importDefault(require("../components/CardTitle"));
const Theme_1 = require("../Theme");
const ThemeContext_1 = require("../ThemeContext");
const Benefits_1 = __importDefault(require("../api/Benefits"));
const UserContext_1 = require("../contexts/UserContext");
const Screen_1 = __importDefault(require("../components/Screen"));
const MasonryList_1 = __importDefault(require("../components/MasonryList"));
const Loading_1 = __importDefault(require("../components/Loading"));
const Card_1 = __importDefault(require("../components/Card"));
const BenefitDetails_1 = __importDefault(require("../partials/BenefitDetails"));
const HealthAssistCard_1 = __importDefault(require("../partials/HealthAssistCard"));
const EnrollmentOpportunityMessage_1 = __importDefault(require("../partials/EnrollmentOpportunityMessage"));
const SpendingAccountCard_1 = __importDefault(require("../partials/SpendingAccountCard"));
const EmployeeAssistanceProgramCard_1 = __importDefault(require("../partials/EmployeeAssistanceProgramCard"));
const RetirementSummaryCard_1 = __importDefault(require("../partials/RetirementSummaryCard"));
const ResponsiveContext_1 = require("../contexts/ResponsiveContext");
const FadeInView_1 = __importDefault(require("../components/FadeInView"));
const LifeEventsCard_1 = __importDefault(require("../partials/LifeEventsCard"));
;
const BenefitCard = (props) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    const STYLES = (0, Theme_1.useGlobalStyles)();
    switch (props.data.category) {
        case "LifeEvent":
            return ((0, jsx_runtime_1.jsx)(LifeEventsCard_1.default, { navigation: props.navigation }));
        case "HealthAssist":
            return ((0, jsx_runtime_1.jsx)(HealthAssistCard_1.default, { data: props.data, navigation: props.navigation }));
        case "OpenEnrollment":
            return ((0, jsx_runtime_1.jsx)(EnrollmentOpportunityMessage_1.default, { topSpace: true, navigation: props.navigation }));
        case "FSA/HSA":
            return ((0, jsx_runtime_1.jsx)(SpendingAccountCard_1.default, { adminView: props.adminView, data: props.data, navigation: props.navigation }));
        case "Retirement":
            return (props.limitedView || (0, jsx_runtime_1.jsx)(RetirementSummaryCard_1.default, { headerText: t('common:screenTitles.retirement'), footerActions: true, headerEdit: false, navigation: props.navigation }));
        case "EAP":
            return ((0, jsx_runtime_1.jsx)(EmployeeAssistanceProgramCard_1.default, { data: props.data, navigation: props.navigation }));
        default:
            return ((0, jsx_runtime_1.jsxs)(Card_1.default, { style: { paddingBottom: 12 }, children: [(0, jsx_runtime_1.jsx)(CardTitle_1.default, { title: props.data?.category ?? t('company:labels.other'), "aria-label": props.data?.category ?? t('company:labels.other'), style: { marginBottom: 8 } }), (0, jsx_runtime_1.jsx)(react_native_1.View, { style: [STYLES.separator, { marginHorizontal: -12, marginBottom: 6 }] }), (0, jsx_runtime_1.jsx)(BenefitDetails_1.default, { data: props.data, future: props.view == 'future', onViewCard: () => props.navigation.navigate('BenefitPopupScreen', {
                            data: props.data,
                            benefit: props.data?.category?.toLowerCase(),
                            view: 'card',
                            adminView: props.adminView,
                            employeeId: props?.employeeId
                        }), adminView: props.adminView, navigation: props.navigation })] }));
    }
};
exports.BenefitCard = BenefitCard;
function MyBenefits(props) {
    const { t } = (0, react_i18next_1.useTranslation)();
    const THEME = (0, ThemeContext_1.useTheme)();
    const userContext = react_1.default.useContext(UserContext_1.UserContext);
    const { size, columns } = (0, ResponsiveContext_1.useResponsiveContext)();
    const promise = react_1.default.useRef(null);
    const futurePromise = react_1.default.useRef(null);
    const [cards, setCards] = react_1.default.useState([]);
    const [futureCards, setFutureCards] = react_1.default.useState([]);
    const [status, setStatus] = react_1.default.useState(null);
    const [futureStatus, setFutureStatus] = react_1.default.useState(null);
    const [view, setView] = react_1.default.useState('current');
    const [refreshing, setRefreshing] = react_1.default.useState(false);
    const limitedView = userContext.isFormer || userContext.isContractor;
    const refresh = react_1.default.useCallback(async () => {
        promise.current?.cancel();
        futurePromise.current?.cancel();
        setStatus("loading");
        setFutureStatus("loading");
        setFutureCards([]);
        setCards([]);
        // Show only FSA/HSA for former employees/contractors
        if (limitedView) {
            promise.current = (0, cancelable_promise_1.cancelable)(userContext.getToken().then(async (token) => {
                try {
                    const spendingAccountsData = await Benefits_1.default.getSpendingAccounts(token);
                    let hraData = null;
                    if (spendingAccountsData?.spendingAccounts.length === 0 || !spendingAccountsData?.hasSponsoredPlan) {
                        try {
                            hraData = await Benefits_1.default.getReimbursementArrangement(token);
                        }
                        catch (e) { /* Not an error if HRA doesn't exist */ }
                    }
                    const showCard = spendingAccountsData?.isActiveOrRecentlyTerminated && (spendingAccountsData?.spendingAccounts.length > 0 || spendingAccountsData?.hasSponsoredPlan || hraData?.hasHadSponsoredPlan);
                    if (showCard) {
                        setCards([{ category: 'FSA/HSA', spendingAccountsList: spendingAccountsData, reimbursementArrangement: hraData }]);
                    }
                    else {
                        setCards([]);
                    }
                }
                catch (e) {
                    if (e !== 204)
                        setStatus('error');
                }
                finally {
                    setStatus('done');
                    setFutureStatus('done');
                }
            }));
            return;
        }
        promise.current = (0, cancelable_promise_1.cancelable)(userContext
            .getToken()
            .then((token) => {
            Benefits_1.default.getList(token).then((data) => {
                var cards = [
                    ...data?.benefits?.filter((p) => p.category == "Medical"),
                    ...data?.benefits?.filter((p) => p.category == "Dental"),
                    ...data?.benefits?.filter((p) => p.category == "Vision"),
                    { category: "Retirement" },
                    ...data?.benefits?.filter((p) => !["Medical", "Dental", "Vision"].includes(p.category)),
                ];
                const eligible = data?.isEmploymentTypeEligible === true;
                if (eligible) {
                    cards.push({ category: "EAP" });
                    if (!userContext.isInternal)
                        cards.push({ category: "HealthAssist" });
                }
                Benefits_1.default.isCreditBack(token).then(async (response) => {
                    // Don't show Life Events card if the client is credit back (doesn't have Nextep benefits)
                    if (response.isCreditBack == false) {
                        cards.unshift({ category: "LifeEvent" });
                    }
                    try {
                        const spendingAccountsData = await Benefits_1.default.getSpendingAccounts(token);
                        let hraData = null;
                        if (spendingAccountsData?.spendingAccounts.length === 0 || !spendingAccountsData?.hasSponsoredPlan) {
                            try {
                                hraData = await Benefits_1.default.getReimbursementArrangement(token);
                            }
                            catch (e) { /* Not an error if HRA doesn't exist */ }
                        }
                        const showCard = spendingAccountsData?.isActiveOrRecentlyTerminated && (spendingAccountsData?.spendingAccounts.length > 0 || spendingAccountsData?.hasSponsoredPlan || hraData?.hasHadSponsoredPlan);
                        if (showCard) {
                            const retirementIndex = cards.findIndex(c => c.category === 'Retirement');
                            if (retirementIndex !== -1) {
                                cards.splice(retirementIndex - 1, 0, { category: 'FSA/HSA', spendingAccountsList: spendingAccountsData, reimbursementArrangement: hraData });
                            }
                            else {
                                cards.push({ category: 'FSA/HSA', spendingAccountsList: spendingAccountsData, reimbursementArrangement: hraData });
                            }
                        }
                    }
                    catch (e) {
                        // If API fails, do nothing, card won't be shown.
                    }
                    await Benefits_1.default.getEnrollmentStatus(token).then((openEnrollmentData) => {
                        if (openEnrollmentData?.isOpen) {
                            cards.unshift({ category: "OpenEnrollment" });
                        }
                    }).finally(() => {
                        setCards(cards);
                        setStatus("done");
                    });
                });
            });
        })
            .catch((e) => {
            setStatus("error");
        }));
        futurePromise.current = (0, cancelable_promise_1.cancelable)(userContext
            .getToken()
            .then((token) => {
            Benefits_1.default.getListFuture(token).then((data) => {
                var cards = [
                    ...data?.filter((p) => p.category == "Medical"),
                    ...data?.filter((p) => p.category == "Dental"),
                    ...data?.filter((p) => p.category == "Vision"),
                    ...data?.filter((p) => !["Medical", "Dental", "Vision"].includes(p.category)),
                ];
                setFutureCards(cards);
                setFutureStatus("done");
            });
        })
            .catch((e) => {
            setFutureStatus("error");
        }));
    }, [limitedView, userContext.isInternal, userContext.client?.id, userContext.getToken]);
    const onRefresh = react_1.default.useCallback(() => {
        setRefreshing(true);
        Promise.resolve(refresh()).finally(() => setRefreshing(false));
    }, [refresh]);
    react_1.default.useEffect(() => {
        refresh();
        return () => {
            promise.current?.cancel();
            futurePromise.current?.cancel();
        };
    }, [refresh]);
    return ((0, jsx_runtime_1.jsxs)(Screen_1.default, { onRefresh: onRefresh, refreshing: refreshing, children: [(0, jsx_runtime_1.jsx)(react_native_1.View, { style: columns == 1 ? {} : { marginVertical: 6, marginHorizontal: 16 }, children: (0, jsx_runtime_1.jsx)(react_native_1.Image, { resizeMode: 'cover', source: size != 'sm' ? Theme_1.IMAGES.BenefitsBackgroundWeb : Theme_1.IMAGES.BenefitsBackground, style: { width: '100%', height: 'auto', aspectRatio: size != 'sm' ? 11.2 : 5.6, marginTop: size != 'sm' ? 12 : 4, borderRadius: size != 'sm' ? 4 : 0 } }) }), futureStatus == "done" && futureCards.length > 0
                &&
                    (0, jsx_runtime_1.jsx)(react_native_1.View, { style: {
                            paddingVertical: 6, marginTop: size != 'sm' ? 12 : 4,
                            flexDirection: 'row', gap: 6,
                            alignSelf: 'center'
                        }, children: (0, jsx_runtime_1.jsxs)(react_native_1.Pressable, { onPress: () => setView((view == 'current') ? 'future' : 'current'), style: {
                                backgroundColor: THEME.CardBackground,
                                borderColor: THEME.Gray, borderWidth: 1, borderRadius: 4,
                                flexDirection: 'row', gap: 2,
                                // @ts-ignore
                                userSelect: 'none'
                            }, children: [(0, jsx_runtime_1.jsxs)(react_native_1.View, { style: {
                                        backgroundColor: (view == 'future') ? THEME.CardBackground : THEME.Primary,
                                        borderColor: THEME.CardBackground, borderWidth: 2, borderRadius: 5,
                                        paddingVertical: 6, paddingHorizontal: 10,
                                        flexDirection: 'row', gap: 6, alignItems: 'center'
                                    }, children: [(0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { icon: Theme_1.ICONS.Solid.ClipboardList, size: 18, color: (view == 'future') ? THEME.Text : THEME.CardBackground, style: { outlineWidth: 0 } }), (0, jsx_runtime_1.jsx)(react_native_1.Text, { style: {
                                                fontSize: 16, fontWeight: '400',
                                                color: (view == 'future') ? THEME.Text : THEME.CardBackground
                                            }, children: t('common:labels.current') })] }), (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: {
                                        backgroundColor: (view == 'future') ? THEME.Primary : THEME.CardBackground,
                                        borderColor: THEME.CardBackground, borderWidth: 2, borderRadius: 5,
                                        paddingVertical: 6, paddingHorizontal: 10,
                                        flexDirection: 'row', gap: 6, alignItems: 'center'
                                    }, children: [(0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { icon: Theme_1.ICONS.Solid.CalendarClock, size: 18, color: (view == 'future') ? THEME.CardBackground : THEME.Text, style: { outlineWidth: 0 } }), (0, jsx_runtime_1.jsx)(react_native_1.Text, { style: {
                                                fontSize: 16, fontWeight: '400',
                                                color: (view == 'future') ? THEME.CardBackground : THEME.Text
                                            }, children: t('common:labels.future') })] })] }) }), view == 'future' && futureStatus == "done" && futureCards.length > 0
                &&
                    (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: { marginHorizontal: 16, flexDirection: 'row', alignItems: 'center', marginBottom: 6, marginTop: size != 'sm' ? 12 : 4, borderWidth: 1, borderColor: `${THEME.Secondary}44`, backgroundColor: `${THEME.Secondary}22`, padding: 12, borderRadius: 4 }, children: [(0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { size: 18, color: THEME.Secondary, icon: Theme_1.ICONS.Regular.CircleExclamation }), (0, jsx_runtime_1.jsx)(react_native_1.Text, { style: { marginLeft: 12, color: THEME.Secondary, fontSize: 14 }, children: t('myBenefits:text.futurePlans') })] }), (0, jsx_runtime_1.jsx)(MasonryList_1.default, { data: view == 'current' ? cards : futureCards, renderItem: ({ item }) => (0, jsx_runtime_1.jsx)(FadeInView_1.default, { children: (0, jsx_runtime_1.jsx)(exports.BenefitCard, { data: item, limitedView: limitedView, view: view, adminView: false, navigation: props.navigation }) }), listEmpty: (0, jsx_runtime_1.jsx)(Card_1.default, { style: { flex: 1 }, children: (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: { padding: 12 }, children: [status == "done"
                                &&
                                    (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: { margin: 24, flexDirection: "row", justifyContent: "center", alignItems: "center" }, children: [(0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { icon: Theme_1.ICONS.Regular.HeartPulse, size: 28, color: THEME.Secondary, style: { marginRight: 8 } }), (0, jsx_runtime_1.jsx)(react_native_1.Text, { style: { color: THEME.TextNull, fontSize: 18 }, children: t('myBenefits:text.noBen') })] }), status == "loading"
                                &&
                                    (0, jsx_runtime_1.jsx)(Loading_1.default, { retryable: true, loading: status == "loading", error: status == "error", onRetry: () => refresh() })] }) }) })] }));
}
